import React from 'react';
import { CycleConflictError } from '../../utils/cycle-conflict-error';

type Props = {
  conflict: CycleConflictError | null;
  onDismiss: () => void;
};

const CycleConflictBanner: React.FC<Props> = ({ conflict, onDismiss }) => {
  if (!conflict) {
    return null;
  }

  return (
    <div className="mb-5 rounded-sm border border-red bg-red/5 p-4 text-black dark:text-white">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-base font-semibold text-red">Channel conflict</h3>
          <p className="mt-1 text-sm">{conflict.message}</p>
          {conflict.conflicts.length > 0 && (
            <ul className="mt-3 flex flex-col gap-2 text-sm">
              {conflict.conflicts.map((item, index) => (
                <li key={`${item.controllerSerialNumber}-${item.channelNumber}-${index}`}>
                  <span className="font-semibold">
                    {item.controllerName || 'Controller'} channel {item.channelNumber}
                  </span>
                  {item.controllerSerialNumber && <span> ({item.controllerSerialNumber})</span>}
                  {item.activeCycleNames?.length > 0 && (
                    <span>
                      {' '}
                      is already used by:{' '}
                      {item.activeCycleNames
                        .map((name, activeIndex) => {
                          const contract = item.activeCycleContractNames?.[activeIndex];
                          return contract ? `${name} (${contract})` : name;
                        })
                        .join(', ')}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
        <button className="text-sm font-semibold text-red" type="button" onClick={onDismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default CycleConflictBanner;
